import { configureStore } from "@reduxjs/toolkit";
import AppReducer from "../modules/app/reducers/AppReducer";
import LoginPageReducer from "../modules/login/reducers/LoginReducer";

export default configureStore({
  reducer: {
    app: AppReducer,
    login: LoginPageReducer
  }
});
